import React from "react";
const ToastContext = /*#__PURE__*/React.createContext({});
export default ToastContext;
//# sourceMappingURL=context.js.map